'use client'
import React from 'react'

export interface FormSectionProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode
}

export const FormSection = ({ children, ...props }: FormSectionProps) => {
    return (
        <div {...props} className={`${props.className ?? ''} bg-shade-opacity-100 border border-shade-opacity-100 p-4`}>
            {children}
        </div>
    )
}
